<template>
  <component
    :is="tagValue"
    class="ak-display-table__cell"
    :class="classList"
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-display-cell />
   */
  name: 'AkDisplayTableCell',

  props: {
    header: {
      default: false,
      type: Boolean,
    },

    tag: {
      default: 'div',
      type: String,
    },
  },

  /**
   * @param {Object} props - The properties of the component
   * @param {Object} options - The setup options
   * @param {Function} options.emit - The emit method for triggering events
   * @param {Function} options.attrs - The attributes for the component.
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup(props) {
    const tagValue = computed(() => {
      return props.tag
    })

    const classList = computed(() => ({
      'ak-display-table-cell--header': props.header,
    }))

    return {
      classList,
      tagValue,
    }
  },
})
</script>
